import { FC } from 'react';
import { useTranslation } from 'react-i18next';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Types
import MediaTypes from 'types/MediaTypes';
import Paths from 'types/Paths';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { sendAnalyticsTrack } from 'store/player/playerAsync';
// Selectors
import { selectQuiz, selectIsQuizStarted } from 'store/quiz/quizSelectors';
// Components
import { Button } from 'components/Buttons';
// Icons
import { GiTrophyCup } from "react-icons/gi";
import { IoIosArrowForward } from "react-icons/io";

const ButtonPlayNow:FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const isQuizStarted:boolean | undefined = useAppSelector(selectIsQuizStarted);

  const { buttonTitle } = quiz.landingPage;

  const navigateTo = useNavigateTo();

  const handleClick = () => {
    let path:Paths = 'countdown';
    let params = {};
    if ( quiz.waiver.enabled ){
      path = 'waiver';
    } else {
      if ( quiz.brandVideo ){
        path = 'media';
        params = { mediaType: MediaTypes.BrandVideo };
      }
    }
    dispatch(sendAnalyticsTrack({ event: 'quizStart', quizId: quiz._id }));
    navigateTo(path, params);
  }

  const buttonText = buttonTitle ?? t('buttons.playNow');

  if ( !isQuizStarted || !quiz.questions?.length ) return null;
  return (
    <div className="mb-3 flex justify-center">
      <Button
        className="w-11/12 !text-xl uppercase primary-button flex items-center justify-between"
        onClick={handleClick}
        size="small"
      >
        <GiTrophyCup className="text-2xl" />
        {buttonText}
        <IoIosArrowForward className="text-2xl" />
      </Button>
    </div>
  )
}

export default ButtonPlayNow;
